document.addEventListener('DOMContentLoaded', function() {
  const isDesktop = 'ontouchstart' in document.documentElement
  || navigator.maxTouchPoints > 0
  || navigator.msMaxTouchPoints > 0;

  const parallax = document.querySelectorAll('.img-parallax');
  let speed = 2;

  parallax.forEach((imgElm) => {
    const img = imgElm;
    const imgParent = imgElm.parentElement;
    speed = img.dataset.speed ? img.dataset.speed : speed;

    function parallaxImg () {
      const imgY = imgParent.offsetTop;
      const winY = window.pageYOffset || document.documentElement.scrollTop;
      const winH = window.innerHeight;
      const parentH = imgParent.offsetHeight;

      const winBottom = winY + winH;
      let imgPercent;

      if (winBottom > imgY && winY < imgY + parentH) {
        // Number of pixels shown after block appear
        const imgBottom = ((winBottom - imgY) * speed);
        // Max number of pixels until block disappear
        const imgTop = winH + parentH;
        // Porcentage between start showing until disappearing
        imgPercent = ((imgBottom / imgTop) * 100) + (100 - (speed * 100));
      }

      img.style.top = `${imgPercent}%`;
      img.style.transform = `translateY(-${imgPercent}%)`;
    }

    parallaxImg();

    document.addEventListener('scroll', parallaxImg);
  });

  if (!isDesktop) {
    document.body.className += ' hasHover';
  }
});

//* ========= Font loader ========== *//

let intervalFontLoader = null;
let intervalLastFontLoader = null;

function fontLoadListener() {
  let hasLoaded = false;

  try {
    hasLoaded = document.fonts.check('16px signo');
  } catch (error) {
    console.info(`document.fonts API error: ${error}`);
    fontLoadedSuccess();
    return;
  }

  if(hasLoaded) {
    fontLoadedSuccess();
  }
}

function fontLoadedSuccess() {
  if(intervalFontLoader) {
    clearInterval(intervalFontLoader);
  }

  if(intervalLastFontLoader) {
    clearInterval(intervalLastFontLoader);
  }

  document.getElementsByTagName("body")[0].classList.remove('skeleton-font--loading');
}

intervalFontLoader = setInterval(fontLoadListener, 500);
intervalLastFontLoader = setInterval(fontLoadedSuccess, 2000);

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.focus();
}

function getAllUrlParams(url) {
  // get query string from url (optional) or window
  var queryString = url ? url.split('?')[1] : window.location.search.slice(1);
  // we'll store the parameters here
  var obj = {};

  // if query string exists
  if (queryString) {
    // stuff after # is not part of query string, so get rid of it
    queryString = queryString.split('#')[0];

    // split our query string into its component parts
    var arr = queryString.split('&');

    for (var i = 0; i < arr.length; i++) {
      // separate the keys and the values
      var a = arr[i].split('=');
      // set parameter name and value (use 'true' if empty)
      var paramName = a[0];
      var paramValue = typeof (a[1]) === 'undefined' ? true : a[1];

      // (optional) keep case consistent
      paramName = paramName.toLowerCase();
      if (typeof paramValue === 'string') paramValue = paramValue.toLowerCase();

      // if the paramName ends with square brackets, e.g. colors[] or colors[2]
      if (paramName.match(/\[(\d+)?\]$/)) {
        // create key if it doesn't exist
        var key = paramName.replace(/\[(\d+)?\]/, '');
        if (!obj[key]) obj[key] = [];

        // if it's an indexed array e.g. colors[2]
        if (paramName.match(/\[\d+\]$/)) {
          // get the index value and add the entry at the appropriate position
          var index = /\[(\d+)\]/.exec(paramName)[1];
          obj[key][index] = paramValue;
        } else {
          // otherwise add the value to the end of the array
          obj[key].push(paramValue);
        }
      } else {
        // we're dealing with a string
        if (!obj[paramName]) {
          // if it doesn't exist, create property
          obj[paramName] = paramValue;
        } else if (obj[paramName] && typeof obj[paramName] === 'string'){
          // if property does exist and it's a string, convert it to an array
          obj[paramName] = [obj[paramName]];
          obj[paramName].push(paramValue);
        } else {
          // otherwise add the property
          obj[paramName].push(paramValue);
        }
      }
    }
  }

  return obj;
}

/*================ Background Check =============*/
function getLuminance (rbgColor, colorType) {
  let rgb = rbgColor.match(/\d+/g);

  if (!rgb && colorType) {
    const defaultRbgColor = colorType == 'light' ? 'rgb(255, 255, 255)' : 'rgb(0, 0, 0)';
    rgb = defaultRbgColor.match(/\d+/g);
  }

  const a = rgb.map(function (v) {
    v /= 255;
    return v <= 0.03928
        ? v / 12.92
        : Math.pow( (v + 0.055) / 1.055, 2.4 );
  });

  return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
}

const hexToRgb = function (hex) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : null;
}

function backgroundCheck(target) {
  const elements = document.querySelectorAll(target);
  const darkColor = window.iconColors.dark;
  const lightColor = window.iconColors.light;
  const darkColorLuminance = getLuminance(darkColor, 'dark');
  const lightColorLuminance = getLuminance(lightColor, 'light');

  if (!elements.length) {
    return;
  }

  elements.forEach((elem) => {
    let match;
    const parent = elem.parentElement;
    const colorElm = parent.querySelectorAll('[data-color-element]');
    const str = elem.style.backgroundImage;

    if (!elem.currentSrc && str) {
      const regex = /\(([^)]+)\)/;
      match = regex.exec(str)[1].replace(/"/g, '');
    } else {
      match = elem.src;
    }

    if (match) {
      RGBaster.colors(match, {
        success: function (colors) {
          const colorLuminance = getLuminance(colors.dominant);
          const ratioDark = darkColorLuminance > colorLuminance
          ? ((colorLuminance + 0.05) / (darkColorLuminance + 0.05))
          : ((darkColorLuminance + 0.05) / (colorLuminance + 0.05));

          const ratioLigth = lightColorLuminance > colorLuminance
          ? ((colorLuminance + 0.05) / (lightColorLuminance + 0.05))
          : ((lightColorLuminance + 0.05) / (colorLuminance + 0.05));

          const colorText = ratioLigth < ratioDark ? 'white' : 'black';

          if (elem.classList.contains('chip-color')) {
            const elmClass = colorText == 'black' ? 'chip-color--dark' : 'chip-color--light';
            elem.classList.add(elmClass);
          } else {
            elem.style.color = colorText;

            if (colorElm.length) {
              colorElm.forEach((e) => {
                e.style.color = colorText;
              });
            }
          }
        }
      });
    } else {
      const hexCode = elem.style.backgroundColor;

      if (hexCode) {
        const rgb = window.getComputedStyle(elem).backgroundColor;
        const colorLuminance = getLuminance(rgb);
        const ratioDark = darkColorLuminance > colorLuminance
          ? ((colorLuminance + 0.05) / (darkColorLuminance + 0.05))
          : ((darkColorLuminance + 0.05) / (colorLuminance + 0.05));
        const ratioLigth = lightColorLuminance > colorLuminance
          ? ((colorLuminance + 0.05) / (lightColorLuminance + 0.05))
          : ((lightColorLuminance + 0.05) / (colorLuminance + 0.05));

        const colorText = ratioLigth < ratioDark ? 'white' : 'black';

        if (elem.classList.contains('chip-color')) {
          const elmClass = colorText == 'black' ? 'chip-color--dark' : 'chip-color--light';
          elem.classList.add(elmClass);
        } else {
          elem.style.color = colorText;

          if (colorElm.length) {
            colorElm.forEach((e) => {
              e.style.color = colorText;
            });
          }
        }
      }
    }
  })
}

function hideUnavailableColors(colorSwatch) {
  if (colorSwatch.length) {
    colorSwatch.forEach((elm) => {
      if (!elm.style.backgroundColor && !elm.style.backgroundImage) {
        elm.classList.add('hide');
      }
    });
  } else {
    if (colorSwatch.style && !colorSwatch.style.backgroundColor && !colorSwatch.style.backgroundImage) {
      colorSwatch.classList.add('hide');
    }
  }
}

/*================ Form Validations =============*/
function validateStringEmail (email) {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

function validateFormInput (inputElement) {
  const inputType = inputElement.getAttribute('type');
  let isValid = false;
  let errorTxt;

  switch (inputType) {
    case 'email':
      isValid = validateStringEmail(inputElement.value);
      errorTxt = inputElement.value === '' ? window.loginStrings.errorEmailRequired : window.loginStrings.errorEmailInvalid;
      break;
    case 'password':
      if (inputElement.id === 'CustomerPassword') {
        isValid = inputElement.value !== '';
        errorTxt = window.loginStrings.errorPasswordRequired;
      } else {
        isValid = inputElement.value !== '' && inputElement.value.length >= 5;
        errorTxt = inputElement.value === '' ? window.loginStrings.errorPasswordRequired : window.loginStrings.errorPasswordTooShort;
      }
      break;
    default:
      isValid = inputElement.value !== '';

      if ( inputElement.name === 'address[country]') {
        isValid = inputElement.value !== '---';
      }
  }

  if (!isValid) {
    const fieldWrapper = inputElement.parentElement;
    const hasErrorMessage = fieldWrapper.nextElementSibling ? fieldWrapper.nextElementSibling.classList.contains('input-error-message') : null;
    const iconError = fieldWrapper.querySelector('.field-wrapper__icon-error');

    if (iconError) {
      iconError.classList.remove('hide');
    }

    if (hasErrorMessage) {
      const errorMsgElm = fieldWrapper.nextElementSibling;
      const formRequirement = errorMsgElm.nextElementSibling ? errorMsgElm.nextElementSibling.classList.contains('requirement-form') : null;

      if (formRequirement) {
        errorMsgElm.nextElementSibling.classList.add('hide');
      }

      if (errorTxt) {
        errorMsgElm.querySelector('span:not(.visually-hidden)').textContent = errorTxt;
      }

      errorMsgElm.classList.remove('hide');
    }

    inputElement.classList.add('input--error');
    inputElement.setAttribute('aria_invalid', 'true');
    inputElement.setAttribute('aria_describedby', `${inputElement.id}-error`);
  }

  return isValid;
}

function validateForm (formElement) {
  const inputsElm =  Array.from(formElement.querySelectorAll('[aria-required]'));
  let checker = arr => arr.every(v => v === true);

  const validationArray = inputsElm.map((inputElem) => {
    const validateGroup = inputElem.dataset.group;

    if (validateGroup) {
      const inputGroup = Array.from(formElement.querySelectorAll(`[data-group='${validateGroup}']`));

      const checkValues = inputGroup.map((input) => {
        const subgroupRequired = input.dataset.groupRequired || null;

        if (subgroupRequired) {
          const inputSubgroup = Array.from(formElement.querySelectorAll(`[data-group-required='${subgroupRequired}']`));
          let invalidSubgroup = false;

          inputSubgroup.forEach((i) => {
            if (i.value === '') {
              invalidSubgroup = true;
            }
          });

          if (invalidSubgroup) {
            return true;
          }
        }

        return input.value === '';
      });

      const invalidGroup = checker(checkValues);

      if (!invalidGroup) {
        return true;
      }
    }

    return validateFormInput(inputElem);
  });

  return checker(validationArray);
}

function removeErrorStyle (inputElem) {
  const fieldWrapper = inputElem.parentElement;
  const hasErrorMessage = fieldWrapper.nextElementSibling ? fieldWrapper.nextElementSibling.classList.contains('input-error-message') : null;
  const iconError = fieldWrapper.querySelector('.field-wrapper__icon-error');

  if (iconError) {
    iconError.classList.add('hide');
  }

  if (hasErrorMessage) {
    const errorMsgElm = fieldWrapper.nextElementSibling;
    const formRequirement = errorMsgElm.nextElementSibling ? errorMsgElm.nextElementSibling.classList.contains('requirement-form') : null;

    if (formRequirement) {
      errorMsgElm.nextElementSibling.classList.remove('hide');
    }
    errorMsgElm.classList.add('hide');
  }

  inputElem.classList.remove('input--error');
  inputElem.classList.remove('input--not-error-msg');
  inputElem.removeAttribute('aria_invalid');
  inputElem.removeAttribute('aria_describedby');
}

function clearInputErrors (formElement) {
  const inputsElm = formElement.querySelectorAll('[aria-required]');
  const formMsgErrors = formElement.querySelectorAll('.form-message--error');

  inputsElm.forEach((inputElm) => {
    let eventName = 'keyup';

    if (inputElm.tagName === 'SELECT') {
      eventName = 'change';
    }

    inputElm.addEventListener(eventName, function (event) {
      const currentInput = inputElm;

      if (currentInput.classList.contains('input--error')) {
        const validateGroup = currentInput.dataset.group;

        if (validateGroup) {
          const inputGroup = Array.from(formElement.querySelectorAll(`[data-group='${validateGroup}']`));

          inputGroup.forEach((input) => {
            removeErrorStyle(input);
          });
        }

        removeErrorStyle(currentInput);
      }

      if (formMsgErrors.length) {
        formMsgErrors.forEach((formMsgError) => {
          formMsgError.classList.add('hide');
          formMsgError.classList.remove('form-message--success-field');
        });
      }
    });
  });
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);

  for (const key of formData.keys()) {
    const regex = /(?:^(properties\[))(.*?)(?:\]$)/;

    if (regex.test(key)) {
      obj.properties = obj.properties || {};
      obj.properties[regex.exec(key)[2]] = formData.get(key);
    } else {
      obj[key] = formData.get(key);
    }
  }

  return JSON.stringify(obj);
};

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

Shopify.money_format = "${{amount}}";

Shopify.formatMoney = function(cents, format) {
  if (typeof cents === 'string') { cents = cents.replace('.', ''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || moneyFormat;

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number === null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.');
    var dollarsAmount = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      '$1' + thousands
    );
    var centsAmount = parts[1] ? decimal + parts[1] : '';
    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case 'amount_no_decimals_with_space_separator':
      value = formatWithDelimiters(cents, 0, ' ');
      break;
    case 'amount_with_apostrophe_separator':
      value = formatWithDelimiters(cents, 2, "'");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    const summaryElements = this.querySelectorAll('summary');
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.userAgent.includes('iPhone')) document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach(element => {
      element.setAttribute('role', 'button');
      element.setAttribute('aria-expanded', false);
      element.setAttribute('aria-controls', element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      const trapFocusElm = detailsElement.querySelector('button') || detailsElement.querySelector('input:not([type="hidden"]):not([type="number"])');

      if (trapFocusElm) {
        trapFocus(summaryElement.nextElementSibling, trapFocusElm);
      }

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);

    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const isMainClose = event.currentTarget.classList.contains('modal__close-main-button');

    if (isMainClose) {
      this.closeMenuDrawer(event);
      return;
    }

    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.shopify-section-header');
    this.headerMenuDrawer = this.headerMenuDrawer || document.querySelector('.menu-drawer__header');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
      document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.headerMenuDrawer.offsetHeight)}px`);
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    const scrollY = window.scrollY;
    document.body.classList.add('overflow-hidden');
    document.body.style.top = `-${scrollY}px`;
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
  }

  hide() {
    const scrollY = document.body.style.top;
    document.body.classList.remove('overflow-hidden');
    document.body.style.top = '';
    window.scrollTo(0, parseInt(scrollY || '0') * -1);
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.$ = jQuery = theme.jQuery;
    this.thumbnailsWrapper = this.querySelector('.thumbnails-wrapper');
    this.productSingleWrapper = this.querySelector('.product-single__wrapper');
    this.sliderWrapper = this.querySelector('.product-single__media-group__wrap');
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.imageZoomWrapper = this.querySelectorAll('[data-image-zoom-wrapper]');
    this.zoomEnabled = this.querySelector('[data-image-zoom-wrapper]') ? this.querySelector('[data-image-zoom-wrapper]').classList.contains('js-zoom-enabled') : null;
    this.initBreakpoints();
  }

  initBreakpoints() {
    enquire.register('screen and (min-width: 1120px)', {
      match: () => {
        if (this.zoomEnabled) {
          this.imageZoomWrapper.forEach((el) => {
            this.enableZoom(el);
          });
        }
        this.bpSmall = false;
      },
      unmatch: () => {
        // destroy image zooming if enabled
        if (this.zoomEnabled) {
          this.imageZoomWrapper.forEach((el) => {
            this.destroyZoom(el);
          });
        }
        this.bpSmall = true;
      }
    });
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderLastItem.clientWidth : this.slider.scrollLeft - this.sliderLastItem.clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  enableZoom(el) {
    var zoomUrl = el.dataset.zoom;
    this.$(el).zoom({
      url: zoomUrl,
      callback: function(){
        this.classList.add('loaded');
      }
    });
  }

  destroyZoom(el) {
    this.$(el).trigger('zoom.destroy');
  }
}

customElements.define('slider-component', SliderComponent);

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.errorEvent = new Event('error', { bubbles: true });

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    const maxNumberValue = parseInt(this.input.getAttribute('max')) || null;
    const parentElem = event.target.parentElement;
    const plusButton = parentElem.querySelector('.qtyplus');
    const minusButton = parentElem.querySelector('.qtyminus');
    const inputNumberValue = parseInt(this.input.value);

    if (!maxNumberValue || inputNumberValue < maxNumberValue) {
      event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    } else if (inputNumberValue === maxNumberValue && event.target.name === 'minus') {
      this.input.stepDown();
    }

    if (maxNumberValue && event.target.name === 'plus') {
      const newValue = parseInt(this.input.value);
      if (this.input.dataset.lowStock && newValue == maxNumberValue && newValue <= 5) {
        this.input.dispatchEvent(this.errorEvent);
        plusButton.setAttribute('disabled', true);
      } else if (inputNumberValue >= maxNumberValue) {
        this.input.dispatchEvent(this.errorEvent);
        plusButton.setAttribute('disabled', true);
      }
    } else {
      plusButton.removeAttribute('disabled');
    }

    if (this.input.value === '1') {
      minusButton.setAttribute('disabled', true);
    } else {
      minusButton.removeAttribute('disabled');
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  updateLimitQuantity( currentVariant, hasNullOptions) {
    const variant = currentVariant;
    const inventoryQuantity = variant.inventory_quantity > 0 ? variant.inventory_quantity : 0;
    const quantitySelector = this.querySelector('.quantity__input');
    const quantityValue = parseInt(quantitySelector.value);
    const plusButton = this.querySelector('.qtyplus');
    const minusButton = this.querySelector('.qtyminus');

    if (hasNullOptions) {
      return;
    }

    plusButton.removeAttribute('disabled');
    quantitySelector.removeAttribute('max');

    if (inventoryQuantity > 0 && quantityValue > inventoryQuantity) {
      quantitySelector.value = inventoryQuantity;
    }

    if (inventoryQuantity > 0) {
      quantitySelector.setAttribute('max', inventoryQuantity);

      if (quantitySelector.dataset.lowStock && quantityValue >= inventoryQuantity && inventoryQuantity <= 5 ) {
        plusButton.setAttribute('disabled', true);
      }
    }

    if ( quantitySelector.value > 1 ) {
      minusButton.removeAttribute('disabled');
    } else {
      minusButton.setAttribute('disabled', true);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

class QuotesSlider extends HTMLElement {
  constructor() {
    super();
    this.$ = jQuery = theme.jQuery;
    this.initQuotesSlider();
  }

  initQuotesSlider() {
    const autoPlay = this.dataset.autoPlay ? false : true;
    const sliderElm = this.querySelector('.quotes-slider-for');
    const $slider = this.$(sliderElm);
    const sliderCount = $slider.data('count');
    const sectionId = this.dataset.section;

    const optionsSliderFor = {
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      pauseOnFocus: true,
      pauseOnHover: true,
      asNavFor: `#quotes-slider-nav-${sectionId}`,
      responsive: [
        {
          breakpoint: 961,
          settings: {
            autoplay: false,
            draggable: true
          }
        }
      ]
    };

    $slider.slick(optionsSliderFor);

    const sliderAutorElm = this.querySelector('.quotes-slider-nav');
    const $sliderAutor = this.$(sliderAutorElm);
    const optionsSliderNav = {
      autoplaySpeed: 12000,
      autoplay: autoPlay,
      slidesToShow: 3,
      slidesToScroll: 1,
      centerPadding: '0',
      centerMode: true,
      arrows: false,
      focusOnSelect: true,
      asNavFor: `#quotes-slider-for-${sectionId}`,
      responsive: [
        {
          breakpoint: 961,
          settings: {
            autoplay: false,
            centerPadding: '26%',
            draggable: true,
            swipeToSlide: true,
            touchMove: true,
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            centerPadding: '21%',
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    }

    if (sliderCount < 4 ) {
      optionsSliderNav.autoplay = false;
    }

    $sliderAutor.slick(optionsSliderNav);
  }
}

customElements.define('quotes-slider', QuotesSlider);

class ShopsSlider extends HTMLElement {
  constructor() {
    super();
    this.$ = jQuery = theme.jQuery;
    this.slider = this.querySelector('[id^="Slider-"]');
    this.initShopsSlider();
  }

  initShopsSlider() {
    const $slider = this.$(this.slider);

    const optionsSliderNav = {
      slidesToShow: 4,
      slidesToScroll: 1,
      centerPadding: '160px',
      centerMode: true,
      arrows: true,
      responsive: [
        {
          breakpoint: 1520,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            centerPadding: '11%'
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            centerPadding: '15%'
          }
        },
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerPadding: '21%'
          }
        }
      ]
    }

    $slider.slick(optionsSliderNav);

    setTimeout(() => {
      $slider.slick('setPosition');
    }, 300);
  }
}

customElements.define('shops-slider', ShopsSlider);

class CircleSlider extends HTMLElement {
  constructor() {
    super();
    this.$ = jQuery = theme.jQuery;
    this.initCircleSlider();
  }

  initCircleSlider() {
    const sliderElm = this.querySelector('.circle-slider-for');
    const $sliderFor = this.$(sliderElm);
    const sliderNavElm = this.querySelector('.circle-slider-nav');
    const $sliderNav = this.$(sliderNavElm);
    const sectionId = this.dataset.section;

    const optionsSliderFor = {
      arrows: false,
      fade: true,
      speed: 500,
      draggable: false,
      responsive: [
        {
          breakpoint: 769,
          settings: {
            draggable: true
          }
        }
      ]
    };

    $sliderFor.on('init', function(event, slick) {
      const circleSlider = slick.$slider.parent();
      const activePie = circleSlider.find(`.pie--${slick.currentSlide + 1}`);

      activePie.addClass('active-pie');
    });

    $sliderFor.slick(optionsSliderFor);

    const slidesQuantity = +sliderNavElm.dataset.slides;
    const optionsSliderNav = {
      vertical: true,
      slidesToShow: slidesQuantity,
      slidesToScroll: slidesQuantity,
      // autoplay: true,
      draggable: false,
      arrows: false,
      focusOnSelect: true,
      asNavFor: `#circle-slider-for-${sectionId}`,
      responsive: [
        {
          breakpoint: 769,
          settings: {
            vertical: false,
            autoplay: false,
            centerMode: true,
            centerPadding: '21%',
            draggable: true,
            swipeToSlide: true,
            touchMove: true,
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    }

    $sliderNav.slick(optionsSliderNav);

    $sliderFor.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
      const circleSlider = slick.$slider.parent();
      const activePie = circleSlider.find(`.pie--${nextSlide + 1}`);

      circleSlider.find('.pie').removeClass('active-pie');
      activePie.addClass('active-pie');
    });

    setTimeout(() => {
      this.$(window).trigger('resize');
    }, 300);
  }
}

customElements.define('circle-slider', CircleSlider);

class VideoColumn extends HTMLElement {
  constructor() {
    super();
    const videos = this.querySelectorAll("video");
    const playOnLoad = this.dataset.playOnLoad;

    if (!playOnLoad) {
      this.initBreakpoints();
    } else {
      this.playVideosOnload(videos);
    }
  }

  initBreakpoints() {
    let videos = this.querySelectorAll("video");

    enquire.register('screen and (min-width: 768px)', {
      match: () => {
        this.bpSmall = false;

        videos.forEach((elm) => {
          elm.addEventListener('mouseover', this.handleMouseOver);
          elm.addEventListener('mouseleave', this.handleMouseleave);
        });
      },
      unmatch: () => {
        this.bpSmall = true;
        videos.forEach((elm) => {
          elm.removeEventListener('mouseover', this.handleMouseOver);
          elm.removeEventListener('mouseleave', this.handleMouseleave);
        });
      }
    });

    enquire.register('screen and (max-width: 768px)', {
      match: () => {
        this.playVideosOnload(videos, true);
      }
    })
  }

  playVideosOnload (videos, disableOnDesktop) {
    videos.forEach((video) => {
      video.muted = true;
      let playPromise = video.play();

      if (playPromise !== undefined) {
        playPromise.then(() => {
          let observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if ( disableOnDesktop && this.bpSmall === false) {
                if (!video.paused) {
                  video.pause();
                }
                observer.disconnect();
                return;
              }

              if (!entry.isIntersecting && !video.paused) {
                video.pause();
              } else if (video.paused) {
                video.play();
              }
            });
          }, { threshold: 0.75 });

          observer.observe(video);
        });
      }
    });
  }

  handleMouseOver (event) {
    const videoElm = event.currentTarget;

    if (videoElm) {
      videoElm.play();
    }
  }

  handleMouseleave (event) {
    const videoElm = event.currentTarget;

    if (videoElm) {
      videoElm.pause();
    }
  }
}

customElements.define('video-column', VideoColumn);

class ContactForm extends HTMLElement {
  constructor() {
    super();
    this.contactForm = this.querySelector('#ContactForm');

    if (this.contactForm) {
      this.submitButton = this.contactForm.querySelector('button[type="submit"]');

      if (this.submitButton) {
        this.submitButton.removeAttribute('disabled');
      }

      clearInputErrors(this.contactForm);

      this.contactForm.addEventListener('submit', this._handleContactSubmit.bind(this));
    }
  }

  _handleContactSubmit(evt) {
    const formIsValid = validateForm(this.contactForm);

    if (formIsValid) {
      if (this.submitButton) {
        this.submitButton.classList.add('btn--loading');
      }
    } else {
      evt.preventDefault();
    }
  }
}

customElements.define('contact-form', ContactForm);

class HeroImage extends HTMLElement {
  constructor() {
    super();

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      this.dataset.animate = true;
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '30px 0px 30px 0px'}).observe(this);
  }
}

customElements.define('hero-image', HeroImage);

class ImageWithText extends HTMLElement {
  constructor() {
    super();
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      this.dataset.animation = true;
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '200px 0px 200px 0px' }).observe(this);
  }
}

customElements.define('image-with-text', ImageWithText);

class VideoContent extends HTMLElement {
  constructor() {
    super();
    this.videoElem = this.querySelector('video.media__video');
    const videoOverlay = this.querySelector('.media__video-overlay');

    if (videoOverlay) {
      const videoButtonPlay = videoOverlay.querySelector('.media__play');
      videoButtonPlay.addEventListener('click', (e) => {
        e.preventDefault();
        const playPromise = this.videoElem.play();

        videoOverlay.classList.add('media__video-overlay--hide');

        if (playPromise !== undefined) {
          playPromise
            .then(() => {})
            .catch(() => {
              this.videoElem.play();
            });
        }
      });
    }

    if (this.videoElem && this.videoElem.hasAttribute('autoplay')) {
      this.videoElem.addEventListener('play', () => {
        this.removeAttribute('data-interrupted');
      });

      this.videoElem.play().catch((error) => {
        if (error.name === 'NotAllowedError') {
          this.setAttribute('data-interrupted', true);
        }
      });
    }
  }
}

customElements.define('video-content', VideoContent);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const recommendations = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;

            const imgsElm = this.querySelectorAll('img');

            imgsElm.forEach((imgElm) => {
              imgElm.onload = () => {
                imgElm.classList.add('loaded');
              }
            });
          }

          if (recommendations.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class ProductGridContainer extends HTMLElement {
  constructor() {
    super();
    if (window.location.search && this.dataset.pagination == 'false') {
      this.loadPages();
    }
  }

  loadPages() {
    const params = getAllUrlParams(window.location.href);
    const page = params.page ? parseInt(params.page) : null;
    if (page && page > 1) {
      const currentUrl = `${window.location.pathname}${window.location.search}`;
      const pagesArray = Array.apply(null, Array(page - 1)).map(function (x, i) { return i; });
      const id = 'data-pagination';
      let productsElm = document.getElementById(id);
      let productsElmIsEmpty = productsElm.dataset.empty;
      const newDiv = document.createElement("div");

      if (productsElmIsEmpty) {
        productsElm.querySelector('.product-grid-container--empty').classList.add('loading');
      }

      const promises = pagesArray.map((pageLoop) => {
        pageLoop = pageLoop + 1;
        const fetchUrl = currentUrl.replace(/page=[0-9]+/,'page='+ pageLoop);
        return fetch(fetchUrl)
          .then((response) => response.text());
      });

      Promise.all(promises)
        .then((texts) => {
          texts.forEach((responseText) => {
            const htmlElm = new DOMParser().parseFromString(responseText, 'text/html');
            const sectionInnerHTML = htmlElm.getElementById(id);
            if (sectionInnerHTML && !sectionInnerHTML.dataset.empty) {
              if (productsElmIsEmpty) {
                document.getElementById('ProductGridContainer').innerHTML = htmlElm.getElementById('ProductGridContainer').innerHTML;
                productsElm = document.getElementById(id);
              }
              newDiv.insertAdjacentHTML('beforeend', sectionInnerHTML.innerHTML);
            }
          });

          if (!productsElm.dataset.empty) {
            productsElm.innerHTML = newDiv.innerHTML;
          }
        });
    }
  }
}

customElements.define('product-grid-container', ProductGridContainer);



